import { PartnershipFlowDetail } from '@purchase/oaflow';
import React from 'react';
import './index.less'

const PartnershipEdit = (
  props: React.ComponentProps<typeof PartnershipFlowDetail>
) => {
  return <PartnershipFlowDetail {...props} className="MPCPartnershipFlowDetail" />;
};

export default PartnershipEdit;
